import gql from "graphql-tag";
import { GraphQlMutationBuilder } from "../../graphQL-mutation.builder";

export interface NewTipoDatoTableData {
  uuidTable: string;
  newInput: any[];
}

export class AddTipoDatoTableDataBuilder {
  private UUID_TABLE: string;
  private NEW_INPUT: string;

  private get _mutation() {
    return gql`
      mutation ($uuidTable: String, $newInput: [TipoDatoTableDataInputField]) {
        insertTipoDatoTableData(td: $uuidTable, input: $newInput) {
          _id
        }
      }
    `;
  }

  public withUuidTable(uuidTable: string): this {
    this.UUID_TABLE = uuidTable;
    return this;
  }

  public withInput(newInput: string): this {
    this.NEW_INPUT = newInput;
    return this;
  }

  public build() {
    let mutationParams: NewTipoDatoTableData;
    const graphQlMutationBuilder: GraphQlMutationBuilder =
      new GraphQlMutationBuilder();
    mutationParams = {
      uuidTable: this.UUID_TABLE,
      newInput: JSON.parse(this.NEW_INPUT),
    };
    return graphQlMutationBuilder
      .withMutation(this._mutation)
      .withParams(mutationParams)
      .build();
  }
}
